import {useContext} from 'react';
import {ErrorContext} from 'store/Error';

function useError() {
    return useContext(ErrorContext);
}

export default useError;
